import { GenericDrawer } from '@/components'
import { INotificationsResponse, NotificationItemBase } from '@/components/Notifications/NotificationItemBase'
import Vue from 'vue'
import { VBadge, VBtn, VContainer, VIcon, VLayout, VList, VListItem, VListItemTitle, VMenu } from 'vuetify/lib'
import './NotificationDrawer.scss'
import { NotificationService } from '@/services/notification'
import { CaptureEvent, Events } from '@/services/AmplitudeService'

export const NotificationDrawer = Vue.component('NotificationDrawer', {
	name: 'NotificationDrawer',

	data: () => ({
		currentTab: 0,
		drawerState: false
	}),

	mounted() {
		const { dispatch } = this.$store
		dispatch('initNotifications')
	},

	computed: {
		notifications(): INotificationsResponse[] {
			const { state } = this.$store
			return state.notifications
		},

		isNotificationsEmpty(): boolean {
			return this.notifications.length == 0
		}
	},

	render() {
		return (
			<GenericDrawer
				title="Notificações"
				ref="drawerNotification"
				vModel={this.drawerState}
				scopedSlots={{
					actions: () => (
						<VMenu
							offset-y
							scopedSlots={{
								activator: ({ on }: { on: any }) => (
									<VBtn icon on={on}>
										<VIcon>mdi-dots-vertical</VIcon>
									</VBtn>
								)
							}}
						>
							<VList>
								<VListItem onClick={() => this.setAllRead()}>
									<VListItemTitle>Marcar todas como lido</VListItemTitle>
								</VListItem>
							</VList>
						</VMenu>
					),
					default: () => {
						if (!this.isNotificationsEmpty)
							return (
								<VContainer id="notification-drawer">
									{this.notifications.map((group) => (
										<NotificationItemBase
											ref="notification-item-ref"
											isVisible={this.drawerState}
											key={group.proposalId}
											notificationGroup={group}
										/>
									))}
								</VContainer>
							)

						if (this.isNotificationsEmpty)
							return (
								<VLayout column fill-height justify-center align-content-center>
									<div class="text-center">
										<VIcon color="#AFB3A5" class="material-icons-outlined" size="72">
											inbox
										</VIcon>
										<p>Não há notificações disponíveis</p>
									</div>
								</VLayout>
							)
					}
				}}
			/>
		)
	},

	methods: {
		openDrawer() {
			const drawer = this.$refs.drawerNotification as GenericDrawer
			drawer.openDrawer()

			CaptureEvent(Events.NotificationView)
		},

		renderNewNoticationsCounter(count: number) {
			return <VBadge class="ml-2" color="red" content={count > 99 ? '99+' : count}></VBadge>
		},

		setAllRead() {
			NotificationService.setAllAsRead()
		}
	}
})

export default NotificationDrawer
